/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Typography from '@material-ui/core/Typography';
import { StyledTableCell } from './StyledTableCell';

export function FeeTextCell({ text, ...props }) {
  return (
    <StyledTableCell {...props}>
      <Typography>{text}</Typography>
    </StyledTableCell>
  );
}
